import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const resendVerificationEmail = (): ReturnType => {
    return Request.post(`/authentication/verify-email/resend`);
};
export default resendVerificationEmail;
